import { Component, Inject, OnInit } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ScrollHandlingEventsEnum } from '@types-custom/models/ui/scroll-model';
import { ISpeedometerModel } from '@types-custom/models/ui/speedometer-model';
import { ICardTrafficSpeedRangeModel } from '@types-custom/models/ui/card-traffic-speed-range-model';
import * as am4core from '@amcharts/amcharts4/core';
import { BehaviorSubject } from 'rxjs';
import {
  adjustConcordanceRotation,
  adjustSpeedometerRotation,
} from '@ui-core/utils/functions/get-indicator-rotation';
import { MapboxDataService } from '@sdk/services/map-box-data/mapbox-data.service';
import { CardMapLinkModel, GeometryTypeEnum, MarkerModelBase } from '@types-custom/models/business/marker.model';
import { colorRangeTypeVectorNameMap } from '@types-custom/models/ui/trafffic-range-color-model';

@Component({
  selector: 'panel-traffic-speedrange',
  templateUrl: './panel-traffic-speedrange.component.html',
  styleUrls: ['./panel-traffic-speedrange.component.scss'],
})
export class PanelTrafficSpeedrangeComponent implements OnInit {
  Icon = Icon;
  cards: ICardTrafficSpeedRangeModel[] = [];
  avSpeedIndicator = 0;
  avFlowIndicator = 0;
  listspeed: Array<any> = [];
  panelActionsDispatcher!: BehaviorSubject<
    ScrollHandlingEventsEnum | undefined
  >;
  linesDispatcher: BehaviorSubject<any>;

  cardList: ICardTrafficSpeedRangeModel[] = [];

  layer = 'TrafficSpeedRange';

  private typeVectorNameMap: { [key: number]: string } = {
    1: 'Genérica',
    2: 'Vías 30',
  };

  private RangeSpeedTypeVector: { [key: number]: Array<number> } = {
    1: [20, 30, 40, 50],
    2: [10, 15, 20, 30]
  }

  //avgSpeedValue: 0;
  avgSpeedProps: ISpeedometerModel = {
    chartType: 4,
    divId: 'avgSpeed',
    descriptionLabel: 'Velocidad promedio',
    unitLabel: 'KM/H',
    labelsClass: 'gap-row-10-px',
    value: 0,
  };

  avgConcordanceProps: ISpeedometerModel = {
    chartType: 5,
    divId: 'avgConcordance',
    descriptionLabel: 'Concordancia',
    unitLabel: '%',
    labelsClass: 'gap-row-10-px',
    value: 0,
  };

  typeOptions: Array<any> = [
    {
      value: 1,
      text: 'Genéricas'
    },
    {
      value: 2,
      text: 'Vías 30'
    }
  ];

  defaultOption = 1;

  colorsSpeed = [
    { id: 0, color: am4core.color('red') },
    { id: 10, color: am4core.color('yellow') },
    { id: 20, color: am4core.color('#00C479') },
  ];

  constructor(
    private mapboxDataService: MapboxDataService,
    @Inject('environment') public environment: any,
  ) {

  }

  ngOnInit(): void {
    this.setIndicators(this.defaultOption);
    this.setGraphic(this.defaultOption);
  }

  optionTypeSelected(optionType: any) {
    this.defaultOption = optionType.value;
    this.setIndicators(this.defaultOption);
    this.setGraphic(this.defaultOption);
  }

  setIndicators(optionType: number) {
    let sumspeedAvg = 0;
    let totDistance = 0;
    let QtysumconcordanceAvg = 0;
    let sumconcordanceAvg = 0;

    const vetorName = this.typeVectorNameMap[optionType];

    const cards: ICardTrafficSpeedRangeModel[] = this.cards.filter((item: any) => item.typeVector === vetorName);
    this.cardList = cards;
    cards.map((cards: ICardTrafficSpeedRangeModel) => {
      cards.speed = (+cards.speed).toFixed(2);
      if (!isNaN(+cards.speed)) {
        sumspeedAvg = sumspeedAvg + +cards.speed * (+cards.distance / 1000);
        if (+cards.speed > 0) {
          totDistance = totDistance + +cards.distance / 1000;
        }
      }
    });

    cards.map((cards: ICardTrafficSpeedRangeModel) => {
      if (!isNaN(+cards.concordance)) {
        QtysumconcordanceAvg += 1;
        const concordance = Math.round(+cards.concordance);
        sumconcordanceAvg =
          sumconcordanceAvg +
          (concordance > 100 ? 100 - concordance : concordance);
      }
    });

    this.avgSpeedProps.value = Math.round(sumspeedAvg / totDistance);
    this.avgConcordanceProps.value = Math.round(
      sumconcordanceAvg / QtysumconcordanceAvg
    );

    this.avgSpeedProps.handClockRotation = adjustSpeedometerRotation(
      this.avgSpeedProps.value
    );

    this.avgConcordanceProps.handClockRotation = adjustConcordanceRotation(
      this.avgConcordanceProps.value
    );
  }

  setGraphic(optionType: number) {
    this.listspeed = [];

    const rangeLimits = this.RangeSpeedTypeVector[optionType];

    const vetorName = this.typeVectorNameMap[optionType];

    const cards: ICardTrafficSpeedRangeModel[] = this.cards.filter((item: any) => item.typeVector === vetorName);

    const quantityMap: { [key: string]: number } = {};

    cards.map((card: ICardTrafficSpeedRangeModel) => {
      const speed = parseFloat(card.speed);

      // Buscar el rango correspondiente para esta velocidad
      const range = rangeLimits.find((limit) => speed <= limit);

      // Si no se encuentra un rango, la velocidad es mayor que el último límite, se asigna el rango máximo
      const rangeLabel = range ? `${range} km/h` : `+ ${rangeLimits[rangeLimits.length - 1]} km/h`;

      // Incrementar la cantidad para este rango
      if (quantityMap[rangeLabel]) {
        quantityMap[rangeLabel] += 1;
      } else {
        quantityMap[rangeLabel] = 1;
      }
    });

    //Right data bar graphic
    const type = this.typeVectorNameMap[this.defaultOption];
    const result = Object.entries(quantityMap).map(([label, qty]) => ({
      id: parseInt(label.split(' ')[0]),
      label,
      dta: 1,
      qty,
      color: (label.split(' ')[0]).toString().includes('+') ?
        colorRangeTypeVectorNameMap[type](Number.MAX_VALUE) :
        colorRangeTypeVectorNameMap[type](parseInt(label.split(' ')[0])),
      name: type,
      speed: label.split(' ')[0]
    }));

    result.sort((a, b) => a.id - b.id);

    this.listspeed = result;
  }
}
